import { authorizedFetch, uploadFile } from '../../utils/api';

const EKYC_BASE = '/api/general/ekyc';

export const ekycApi = {
  initSession(providerCode) {
    return authorizedFetch(`${EKYC_BASE}/init`, {
      method: 'POST',
      body: providerCode ? { providerCode } : {},
    });
  },

  submitOcr(frontCard, backCard) {
    const formData = new FormData();
    formData.append('frontCard', frontCard);
    formData.append('backCard', backCard);
    return uploadFile(`${EKYC_BASE}/ocr`, formData);
  },

  submitFaceMatch(selfie) {
    const formData = new FormData();
    formData.append('selfie', selfie);
    return uploadFile(`${EKYC_BASE}/face-match`, formData);
  },

  submitLiveness(video) {
    const formData = new FormData();
    formData.append('video', video);
    return uploadFile(`${EKYC_BASE}/liveness`, formData);
  },

  chipVerify(chipData) {
    return authorizedFetch(`${EKYC_BASE}/chip-verify`, {
      method: 'POST',
      body: { chipData },
    });
  },

  cancelSession() {
    return authorizedFetch(`${EKYC_BASE}/cancel`, { method: 'POST' });
  },

  confirm() {
    return authorizedFetch(`${EKYC_BASE}/confirm`, { method: 'POST' });
  },

  getStatus() {
    return authorizedFetch(`${EKYC_BASE}/status`);
  },

  getProfile() {
    return authorizedFetch(`${EKYC_BASE}/profile`);
  },
};
